import Pannellum from 'pannellum-react/es/elements/Pannellum';
import React from 'react';
import { getParameterByName } from './utils/getParameterByName';

export function PanoramaViewer() {
    const assetId = getParameterByName('assetid');

    return (
        <div>
            <Pannellum width="100%" height="500px" image={`/api/assets/${assetId}/download`} pitch={10} yaw={180} hfov={110} autoLoad />
        </div>
    );
}
